export const STORY_AUTO_ADVANCE_MS = 7000;

interface StoryPlaybackSlide {
  autoAdvance?: boolean;
}

export function storyPlaybackDelay(
  slide: StoryPlaybackSlide | undefined,
  reducedMotion: boolean,
  paused: boolean,
): number | null {
  if (!slide || reducedMotion || paused || slide.autoAdvance === false) return null;
  return STORY_AUTO_ADVANCE_MS;
}
